import React, { useState } from "react";
import { fetchShopInfo, fetchOpeningHours } from "../../util/customer/httpCustomer";
import { useQuery } from "@tanstack/react-query";
import "./ShopInfo.css";
import { NavLink } from "react-router-dom";
import info from "../../assets/admin/icons/info.svg";
import phone from "../../assets/admin/icons/phone.svg";
import shop from "../../assets/admin/icons/shop.svg";
import chevronDown from "../../assets/admin/icons/chevron-down.svg";
import PrimaryButtonDark from "../shared/PrimaryButtonDark";

const ShopInfo = () => {
   const [activeSection, setActiveSection] = useState('');

   // Fetch shop info met react-query
   const { data: shopData, isLoading: isLoadingShop, isError: isErrorShop, error: errorShop } = useQuery({
      queryKey: ["shopInfo"],
      queryFn: fetchShopInfo,
   });

   // Fetch opening hours met react-query
   const { data: openingHoursData, isLoading: isLoadingHours, isError: isErrorHours, error: errorHours } = useQuery({
      queryKey: ["openingHours"],
      queryFn: fetchOpeningHours,
   });

   if (isLoadingShop || isLoadingHours) {
      return <div>Gegevens laden...</div>;
   }

   if (isErrorShop) {
      return <p className="c-r">Fout bij het laden van de shopinfo: {errorShop.message}</p>;
   }

   if (isErrorHours) {
      return <p className="c-r">Fout bij het laden van de openingsuren: {errorHours.message}</p>;
   }

   const { shopBannerUrl, contactEmail, contactGsm, websiteUrl, shopName, shopAddress, shopDescription } = shopData;
   const daysOfWeek = ["maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag", "zondag"];

   const toggleSection = (section) => {
      setActiveSection(activeSection === section ? '' : section);
   };

   return (
      <header className="bg-w br-15 border-light py-10 px-10">
         <div className="banner-container">
            <img src={`${shopBannerUrl}?t=${Date.now()}`} alt={shopName} className="banner-img br-10" />
         </div>

         <div className="info-sections">
            <div className={`info-section ${activeSection === 'details' ? 'active' : ''}`}>
               <div className="section-header" onClick={() => toggleSection('details')}>
                  <h3 className="f-m">
                     <img src={info} alt="info" />
                     Informatie
                  </h3>
                  <img src={chevronDown} alt="toggle" className="chevron-icon" />
               </div>
               <div className="section-content">
                  <p className="f-s">{shopDescription}</p>
               </div>
            </div>

            <div className={`info-section ${activeSection === 'contact' ? 'active' : ''}`}>
               <div className="section-header" onClick={() => toggleSection('contact')}>
                  <h3 className="f-m">
                     <img src={phone} alt="phone" />
                     Contact
                  </h3>
                  <img src={chevronDown} alt="toggle" className="chevron-icon" />
               </div>
               <div className="section-content">
                  <p className="f-s">{contactEmail}</p>
                  <p className="f-s">{contactGsm}</p>
                  <p className="f-s">{shopAddress}</p>
               </div>
            </div>

            <div className={`info-section ${activeSection === 'hours' ? 'active' : ''}`}>
               <div className="section-header" onClick={() => toggleSection('hours')}>
                  <h3 className="f-m">
                     <img src={shop} alt="shop" />
                     Openingsuren
                  </h3>
                  <img src={chevronDown} alt="toggle" className="chevron-icon" />
               </div>
               <div className="section-content">
                  {openingHoursData && Object.entries(openingHoursData).length > 0 ? (
                     Object.entries(openingHoursData)
                        .filter(([day]) => daysOfWeek.includes(day))
                        .map(([day, hours]) => (
                           <p className="f-s" key={day}>
                              <strong>{day}:</strong> {Array.isArray(hours) && hours.length > 0 ? hours.map(h => `${h.start} - ${h.end}`).join(", ") : "Gesloten"}
                           </p>
                        ))
                  ) : (
                     <p>Geen openingsuren beschikbaar</p>
                  )}
               </div>
            </div>
         </div>

         <PrimaryButtonDark onClick={() => window.open(websiteUrl, '_blank')} style={{ marginTop: '20px' }}>
            Website
         </PrimaryButtonDark>
      </header>
   );
};

export default ShopInfo;
